import { useParams } from 'react-router'
import { RetentionWidget } from '@/widgets/analytics/retention/ui/RetentionWidget'
import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account/hooks'

export const RetentionPage = () => {
    const { groupId: groupIdString } = useParams<{ groupId: string }>()
    const groupId = Number.parseInt(groupIdString ?? '')

    const { activeWorkspace } = useActiveWorkspace()

    if (isNaN(groupId) || activeWorkspace.workspace_type !== 'channel') {
        //TODO: redirect to NotFound
        console.error({ groupId, activeWorkspace })
        return null
    }

    return <RetentionWidget groupId={groupId} activeChannel={activeWorkspace} />
}
